import { atom } from 'jotai';

export const tenantData = atom({
  loading: false,
});
